import { createVanIconComponent } from "./van"

const TvOutlined = createVanIconComponent("tv-o")
export default TvOutlined
